import React from 'react'
import ConflictDropdown from 'duties/filters/conflict-dropdown'
import Search from 'shared/forms/search'
import InactiveRolesToggle from 'duties/filters/inactive-roles'
import DeletedRolesToggle from 'duties/filters/deleted-roles'
import Category from 'duties/permissions/filters/category'
import ActionsDropdown from 'duties/roles/ActionsDropdown'
import RoleTypeDropdown from './role-type-dropdown'

function Filters({
  filterParams,
  setFilterParams,
  setShowBuilder,
  dataType = 'Role'
}) {
  return (
    <div className="d-flex align-items-center flex-wrap gap-2 mb-4 mt-2">
      <div style={{ minWidth: 180 }}>
        <Search params={filterParams} setParams={setFilterParams} />
      </div>
      <div style={{ minWidth: 160 }}>
        <ConflictDropdown
          filterParams={filterParams}
          setFilterParams={setFilterParams}
        />
      </div>
      <div style={{ minWidth: 160 }}>
        <Category params={filterParams} setParams={setFilterParams} />
      </div>
      <div style={{ minWidth: 160 }}>
        <RoleTypeDropdown
          filterParams={filterParams}
          setFilterParams={setFilterParams}
        />
      </div>
      <InactiveRolesToggle
        params={filterParams}
        setParams={setFilterParams}
      />
      <DeletedRolesToggle
        params={filterParams}
        setParams={setFilterParams}
      />
      <div className="ms-auto d-flex align-items-center gap-2">
        <ActionsDropdown
          filterParams={filterParams}
          setShowBuilder={setShowBuilder}
        />
      </div>
    </div>
  )
}

export default Filters
